<div class="ppLogin_content">
  <div class="ppLogin_header">
    <i class="icon-backarrow" (click)="goBack()"></i>
  </div>
  <div class="ppLogin_body">
    <form [formGroup]="verifyDetailsForm" (ngSubmit)="confirm()">
      <div class="loginBody-content">
        <h1 class="loginTitle">{{ 'MODULES.LOGIN.VERIFY_YOUR_DETAILS' | transloco }}</h1>
        <p class="loginDescription">
          {{ 'MODULES.LOGIN.VERIFY_DETAILS_DESCRIPTION' | transloco }}
        </p>
        
        <div class="dsFieldWrap" [ngClass]="{ 'dsFieldError': accountNumberControl?.invalid && (accountNumberControl?.dirty || accountNumberControl?.touched) }">
          <div class="dsLabel">{{ 'MODULES.LOGIN.ACCOUNT_NUMBER' | transloco }}<sup class="dsAsterix">*</sup></div>
          <mat-form-field appearance="outline" floatLabel="never">
            <input formControlName="accountNumber" matInput type="text" required readonly />
          </mat-form-field>
          <div class="dsErrorMsg" *ngIf="accountNumberControl?.invalid && (accountNumberControl?.dirty || accountNumberControl?.touched)">
            <span *ngIf="accountNumberControl?.errors?.['required']">{{ 'MODULES.LOGIN.ACCOUNT_NUMBER_REQUIRED' | transloco }}</span>
          </div>
        </div>

        <div class="dsFieldWrap dsDatePicker" [ngClass]="{ 'dsFieldError': dateOfBirth?.invalid && (dateOfBirth?.dirty || dateOfBirth?.touched) }">
          <div class="dsLabel">{{ 'MODULES.LOGIN.DATE_OF_BIRTH' | transloco }}<sup class="dsAsterix">*</sup></div>
          <mat-form-field appearance="outline" floatLabel="never">
            <input formControlName="dateOfBirth" matInput [matDatepicker]="dobPicker" [placeholder]="datePickerPlaceholder" [max]="maxDate" required readonly />
            <mat-datepicker-toggle matIconSuffix [for]="dobPicker"></mat-datepicker-toggle>
            <mat-datepicker #dobPicker></mat-datepicker>
          </mat-form-field>
          <div class="dsErrorMsg" *ngIf="dateOfBirth?.invalid && (dateOfBirth?.dirty || dateOfBirth?.touched)">
            <span *ngIf="dateOfBirth?.errors?.['required']">{{ 'MODULES.LOGIN.DATE_OF_BIRTH_REQUIRED' | transloco }}</span>
          </div>
        </div>

        <div class="dsFieldWrap" [ngClass]="{ 'dsFieldError': zipCode?.invalid && (zipCode?.dirty || zipCode?.touched) }">
          <div class="dsLabel">{{ 'MODULES.LOGIN.ZIP_CODE' | transloco }}<sup class="dsAsterix">*</sup></div>
          <mat-form-field appearance="outline" floatLabel="never">
            <input formControlName="zipCode" matInput type="text" required />
          </mat-form-field>
          <div class="dsErrorMsg" *ngIf="zipCode?.invalid && (zipCode?.dirty || zipCode?.touched)">
            <span *ngIf="zipCode?.errors?.['required']">{{ 'MODULES.LOGIN.ZIP_CODE_REQUIRED' | transloco }}</span>
          </div>
        </div>
      </div>

      <footer class="loginBody-footer">
        <button type="submit" class="loginAction_btn" [disabled]="!verifyDetailsForm.valid">
          {{ 'MODULES.LOGIN.CONFIRM' | transloco }}
        </button>
      </footer>
    </form>
  </div>
  <div class="login-copyright">
    {{ 'MODULES.LOGIN.COPYRIGHT' | transloco }}
  </div>
</div>
